import { realIframe } from '../../platform/iframe/realIframe';
import { realDevice } from '../../platform/device/realDevice';

export function getViewContext(): string {
  if (realDevice.isWebView) {
    return 'web_view';
  }

  if (realIframe.isEmbedded()) {
    return 'iframe';
  }

  return 'direct';
}
